import { render } from "./CreateAdfsUser.vue?vue&type=template&id=5808bbfa"
import script from "./CreateAdfsUser.vue?vue&type=script&lang=js"
export * from "./CreateAdfsUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__